export const GET_ET_DATES = "GET_ET_DATES";
export const GET_ET_MONTHLY_DATES = "GET_ET_MONTHLY_DATES";
export const GET_ET_FORTNIGHTLY_DATES = "GET_ET_FORTNIGHTLY_DATES";

export const SET_MN_SELECTED_LAYER = "SET_MN_SELECTED_LAYER";
export const SET_FN_SELECTED_LAYER = "SET_FN_SELECTED_LAYER";

export const GET_ET_ERROR = "GET_ET_ERROR";
export const ON_SLIDE = "ON_SLIDE";
export const SELECTED_MENU = "SELECTED_MENU";
export const SELECTED_LAYER = "SELECTED_LAYER";
export const ON_SLIDE_LEFT = "ON_SLIDE_LEFT";
export const ON_SLIDE_RIGHT = "ON_SLIDE_RIGHT";
export const HANDLE_DATE_CHANGE = "HANDLE_DATE_CHANGE";
export const ON_MAP_CLICK = "ON_MAP_CLICK";
export const FETCH_REQUEST = "FETCH_REQUEST";
export const TOGGLE_VISIBLE_GRAPH = "TOGGLE_VISIBLE_GRAPH";
export const TOGGLE_SELECTED_NODE_STATUS = "TOGGLE_SELECTED_NODE_STATUS";
export const SIDEBAR_TOGGLE = "SIDEBAR_TOGGLE";
export const SET_LEGEND = "SET_LEGEND";
export const TECHNICAL_NOTE_TOGGLE = "TECHNICAL_NOTE_TOGGLE";
export const DISCLAIMER_TOGGLE = "DISCLAIMER_TOGGLE";
export const EB_POPUP = "EB_POPUP";
export const WB_POPUP = "WB_POPUP";
export const DIALOG_TOGGLE = "DIALOG_TOGGLE";
export const COMMON_INPUT = "COMMON_INPUT";
export const BASE_LAYER_CHANGE = "BASE_LAYER_CHANGE";
export const DISPLAY_BASELAYER_PANEL = "DISPLAY_BASELAYER_PANEL";
export const DISPLAY_ABOUT_MODAL = "DISPLAY_ABOUT_MODAL";
export const SET_SHOWINFO = "SET_SHOWINFO";
export const WIDTH_UPDATE="WIDTH_UPDATE";
export const INLINE_MODE_CHANGE="INLINE_MODE_CHANGE"